import { AbstractGameView } from "./AbstractGameView";
/**
 * AbstractPayTableCell.ts
 */
export class AbstractPayTableCell extends AbstractGameView {
    createProperties(properties, portraitProperties) {
        super.createProperties(properties, portraitProperties);
        this.uiProperties = this.properties = properties;
    }
    setLabel(key) { }
    update(amount) { }
    inactive() { }
    active() { }
    current() { }
    highlight() { }
    hideFields() { }
    updateSize(properties) {
        this.uiProperties = this.properties = properties;
    }
    getHeight() {
        return this.height;
    }
    getWidth() {
        return this.width;
    }
    getId() {
        return this.uiProperties.id;
    }
}
//# sourceMappingURL=AbstractPayTableCell.js.map